import React , {Component} from "react";
import './styles.css'


export class RanaLahna extends Component{
    constructor(props) {
        super(props);
    }
    render(){
        return(
            <div className="flip-card">
                <div className="flip-card-inner">
                    <div className="col-12 primary-adsil-color-bg flip-card-front" style={{textAlign : 'center' , color : "#fff" , padding : "2rem" , fontSize : "3rem"}}>
                        <div>{this.props.titleBlue}</div>
                    </div>
                    <div className="col-12 back flip-card-back" style={{ backgroundColor : "#707070", textAlign : 'center' , color : "#fff" , padding : "2rem"}}>
                        <div style={{fontSize : '2.5rem'}}>{this.props.titleGray}</div>
                        <div>{this.props.contentGray}</div>
                    </div>
                </div>
            </div>
        )
    }
}

